
export const navigationEnglish = {
    lang: 'en',
    data: {
        NAV: {
            HOME: 'Home',
            MANAGE_BILL: 'Bill management',
            SAVE_DAY: 'Work',
            SALE: 'Product Sale',
            MEMBER: 'Member',
            PAY: 'Pay',
            QTT: 'Quotation',
            COUPON: 'Coupon',
            MEMBER_POINT: 'Member Point',
            REPORT: 'Report',
            REPORT_AR: 'Ar Report',
            REPORT_SALE: 'Sale Report',
            REPORT_STOCK: 'Stock Report',
            REPORT_CDT: 'Creditor Report',
            REPORT_EX: 'Expire Product Report',
            REPORT_PL: 'Profit Loss Report',
            REPORT_USER_SALE: 'Sale Of User',
            REPORT_SALE_CATEGORY: 'SALE CATEGORY REPORT',
            STOCK: 'Stock',
            IMPORT_ST: 'Stock Import',
            ADJUST_ST: 'Stock Adjust',
            TRANSFER_ST: 'Product Transfer',
            SETTING: 'Setting Info',
            ST_COMPANY: 'Setting Company',
            ST_DOC: 'Setting Document',
            ST_EXCHANGE: 'Exchange',
            ST_BRANCH: 'Branch',
            ST_USER: 'User',
            ST_CREDITOR: 'Creditor',
            ST_PRODUCT: 'Product',
            ST_PD_TYPE: 'Product Type',
            ST_PAY_TYPE: 'Pay Type',
            ADD_PAY_TYPE: 'Add pay type',
            ADD_PD_TYPE: 'ADD Product Type',
            ST_NPD_TYPE: 'Type Name',
            ST_ADD_CREDITOR: 'Add Creditor',
            ADD: 'Add',
            SELECT_CTM: 'Select a customer',
            SELECT_PD: 'Select a product',
            MANAGE_PAGE: {
                ALL: 'All',
                BILL_DETAIL: 'Bill details',
                SEND_BILL: 'Bill dispense',
                EDIT_BILL: ' Edit Bill',
                CTM_BRANCH: 'Branch member',
                Delivery_Cover: 'Delivery Cover',
                TABLE: {
                    BILL_ID: 'Bill id',
                    PAY_DATE: 'Pay date',
                    CREATED_DATE: 'Created date',
                    SUM_SALE: 'Sum Sale',
                    DISCOUNT: 'Discount',
                },
            },
            SALE_PAGE: {
                BTN_TEXT: {
                    PAUSE_BILL: 'Bill suspension',
                    CLEAN: 'Clear all items',
                    END_SALE: 'End of sale',
                    END_SALE_AND_PAY: 'Pay exactly and finish the sale',
                    Cancel_BILL: 'Cancel bill breaks',
                    Bill_Sale: 'Print the latest Receipt',
                },
                USER_SALE: 'Salesman',
                SELECT_SALE_PATTERN: {
                    SALE_PATTERN: 'Sales model',
                    RETAIL: 'Retail',
                    WHOLESALE: 'Whole sale',
                },
                QTY: 'Number',
                LIST_PRODUCT: 'Product list',
                TABLE: {
                    PICTURE: 'Picture',
                    PRODUCT: 'Product',
                    PRICE: 'Price',
                    DELETE: 'Delete',
                    KIP: 'Kip',
                },
                DIALOG: {
                    FORM_CUSTOMER: {
                        H_CUSTOMER: 'Customer',
                        NAME_CUT: 'Customer Name',
                        ID_TAXPAYER: 'Taxpayer number',
                        PHONE: 'Phone Number',
                        ADDRESS: 'Address',
                    },
                    FORM_END_SALE: {
                        CREATION_DATE: 'Transaction date',
                        MONEY_cash: 'Cash',
                        MONEY_CREDIT: 'Credit',
                        PRINT: {
                            H_PRINT: 'Print',
                            SLIP: 'Slip',
                        },
                        PAY_CANNEl: 'Distribution channel',
                        HOME_SHOP: 'Storefront',
                        DISCOUNT_BILL: 'Bill Discount',
                        SUM_DISCOUNT: 'Calculated balance',
                    },
                    FORM_MONEY: {
                        SUM_BILL: 'Balance',
                        MONEY_PAID: 'Money paid',
                        DEPOSIT_RECEIVE: 'Receive money / deposit',
                        EX_CHANG: 'Change Money',
                    },
                    Pay_exactly: 'Pay exactly',
                },
            },
            MEMBER_PAGE: {
                TABLE: {
                    CODE: 'Code',
                    NAME: 'Member Name',
                    TEL : 'Phone Number',
                },
                DIALOG: {
                    BRANCH_REGIS: 'Branches registered',
                    TAX_ID : 'TAX ID',
                },
            },
            PAY_PAGE: {
                LIST: 'List',
                SUM: 'Sum',
                ADD_PAY: 'Add Pay',
                EDIT_PAY: 'Edit Pay',
                SELECT_PAY_TYPE: 'Please select a cost type',
            },
            QTT_PAGE: {
                ADD_QTT: 'Add quotation',
                ALL_QTT: 'All quotations',
                SHOW_QTT: 'Show quotation information',
                EDIT_QTT: 'Edit quotations',
                PRINT_QTT: 'Print quotation',
                DIALOG: {
                    MEMBER: 'Customer information',
                },
                PRINT: {
                    SUM_TOTAL: 'Net total',
                    NAME_QTT: 'Bidder name',
                    SIGN: 'sign',
                    QTT_MEMBER: 'Price agreement',
                    QTT_USER: 'Bidder',
                },
            },
            COUPON_PAGE: {
                ADD_COUPON: 'Add Coupon',
                EDIT_COUPON: 'Edit Coupon',
                SHOW_COUPON: 'Detail Coupon',
                MONEY_COUPON: 'Money in coupons',
                EXPIRE_COUPON: 'Expiration date',
                REMARK_STAR: 'Commodity table with red background',
                REMARK_EXPIRE: 'coupon has expired.',
                PRINT_COUPON: 'Print a discount coupon',
                MONEY_IN_COUPON: 'The amount of the coupon',
            },
            MEMBER_POINT_PAGE: {
                NUMBER_POINT_KIP: 'Number of Kip = 1 point',
                KIP_QTY: 'Number of Kip',
            },
            REPORT_AR_PAGE: {
                PAY_SUCCESS: 'Pay successfully',
                NO_PAY: 'Not yet paid',
                DEPOSIT: 'Deposit',
                RECEIVE: 'Receive money',
                CF_SAVE: 'Confirm payment',
                LIST_SUCCESS: 'Successful transaction',
                LIST_NOT: 'Failed to complete the transaction.',
            },
            REPORT_SALE_PAGE: {
                BILL_ID: 'Bill Id',
                PAYMENT: 'Payment',
            },
            REPORT_STOCK_PAGE: {
                BEFORE: 'Before',
                AFTER: 'After',
                TF_OUT: 'Transfer out',
                TF_COME: 'Transfer come',
                AdjustQty: 'Adjustment amount',
                Remaining: 'Remaining',
                Value: 'Inventory value'
            },
            REPORT_CDT_PAGE: {
                IMPORT_DATE: 'Import date',
                DATA: 'Data',
                BUY_FROM: 'Buy from',
            },
            REPORT_EXPIRE_PAGE: {
                TABLE_REMARK: 'Table with yellow background',
                EXPIRE: 'Expired product',
                EXPIRE_H: 'Expires within',
                NO_EXPIRE: 'The product does not expire.',
                EXPIRE_ABOUT: 'Nearly expired product',
            },
            REPORT_PROFIT_PAGE: {
                H_TABLE: {
                    SALES: 'Sales',
                },
                Income: 'Income',
                profit: 'Profit',
            },
            IMPORT_STOCK: {
                ID_IMPORT: 'Import number',
                BILL_IMPORT: 'Import bill',
            },
            ADJUST_STOCK: {
                ADJ_HITORY: 'Stock adjustment history',
            },
            TRANSFER_STOCK: {
                TF_HITORY: 'Product transfer history',
                FORM_BRANCH: 'From the branch',
                TO_BRANCH: 'Go to branch',
                TF_CONFRIM: 'Confirm product transfer',
                TF_DETAIL: 'Product transfer details',
                NUMBER_TF: 'Transfer number',
            },
            COPANY_PAGE: {
                NAME_COPANY: 'Store name',
                UPLOAD_LOGO: 'Upload the shop logo',
            },
            DOC_SETTING: {
                PAPER_SIZE: 'Paper size',
                WIDTH_BILL: 'Bill width',
                HEIGHT_BILL: 'Bill height',
                FONT_SIZE_BILL: 'Bill font size',
                LOGO_WIDTH: 'Logo width',
                LOGO_HEIGHT: 'Logo height',
                PAPER_FONT_SIZE: 'Paper letter size',
            },
            EXCHANGE: {
                KEP_PER_BAHT: 'Baht per Kip',
                DOLLAR_PER_KIP: 'Dollar per kip',
            },
            BRANCH: {
                ADD_BRANCH: 'Add branch',
                EDIT_BRANCH: 'Edit branch'
            },
            USER_PAGE: {
                ADD_USER: 'Add users',
                EDIT_USER: 'Edit user',
                LEVEL: 'Level',
                ADMIN: 'Administrator',
                CASHIER: 'Cashier',
                STOCK: 'Stock',
                ST_SALE: 'Cashier+Stock',
                ST_CS_RP: 'Cashier+Stock+Report'
            },
            FORM_DATE: {
                START_DATE: 'From date',
                END_DATE: 'Up to date',
                DATE: 'Date',
                DAY: 'Day',
            },
            PRODUCT: {
                NAME_PD: 'Product name',
                Total: 'Total',
                RRICE_CONST: 'Cost price',
                ADD_PRODUCT: 'Add products',
                EDIT_PRODUCT: 'Edit product',
                ALL_PRODUCT: 'All products',
                IMPORT_CSV: 'Import products from CSV',
                EXPORT_CSV: 'Export CSV products',
                PRICE_SALE: 'Selling price',
                PRICE_SEND: 'Wholesale price',
                PRINT_BC: 'Print barcode',
                LAMP: 'lamp',
                REMARK_IMPORT: 'Import conditions',
                NO_IMPORT: 'Products with duplicate barcodes The system will not do the import because it is considered a product that is already in the system.',
                NO_COMMA: 'The product title must not contain the symbol.',
                GEN_BARCODE: 'Automatically generate barcode',
                FAIL_IMPORT: 'Found some products, can not list. Please check the list.'
            },
            TABLE_ALL: {
                NO: 'No',
                NAME: 'Name',
                ADDRESS: 'Address',
                'EDIT/DELETE': 'Edit/Delete',
                REMARK: 'Remark',
                EDIT: 'Edit',
                STATUS: 'Status',
                READY_TO_USE: 'Ready to use',
                SELECT: 'Select',
                USERNAME: 'User Name',
            },
            BTN_TEXT: {
                SHOW: 'Show information',
                SHOW_INFO: 'Show details',
                ADD: 'Add List',
                SAVE: 'Save',
                CLOSE: 'Close',
                SEARCH: 'Search',
                SELECT_BRANCH: 'Please select a branch',
                SELECT_BRANCH2: '-----select a branch-----',
                YES: 'Yes',
                PAY: 'Pay',
                LOGIN: 'Login'
            },
            ERROR: {
                CTM_NAME: 'Please enter customer name',
                CTM_PHONE: 'Please enter your phone number',
                CTM_ADDRESS: 'Please enter the address',
                KEY_NAME: 'Please enter your name',
                KEY_USERNAME: 'Please enter your username',
                KEY_PASS: 'Please enter the password',
                SELECT_LEVEL: 'Please select a level',
                PD_NO_INFO: 'No product information',
                CANCEL: 'Cancel',
                SUCCESS: 'Save success',
                DELETE: 'Deleted successfully',
                FAIL: 'Something went wrong',
                DETAIL: 'Detail',
                NOT_VALUE: 'Imported information is not complete',
                VALUE_VALIDATE: 'Please fill out all information',
                PRODUCT_HAVE: 'There are products in the system.',
                CHECK_UPLOAD: 'Please upload the image first.',
                UPLOAD_SUCCESS: 'Uploaded',
                SELECT_FILE: 'Select a file',
                CHECK_USER: 'Already have this worker',
                KEY_BARCODE: 'Please enter Barcode',
                KEY_PD_NAME: 'Please enter product name',
                KEY_P_CONST: 'Please enter cost price',
                KEY_P_SALE: 'Please enter the selling price.',
                KEY_P_SEND: 'Please enter price',
                KEY_NUMBER: 'Please enter a number',
                SELECT_PD_TYPE: 'Please select product type',
                NO_BILL_DAY: 'Can\'t find today\'s latest sales bill',
                CHECK_MONEY: 'Sales are 0, can\'t end the sale.',
                NO_PD: 'No product',
                EXPIRE_COMPANY: 'Expired, please contact sales person.',
                TEL_SERVIECT: 'Contact the service sales department at',
                DAY_SERVIEC: 'Monday-Friday time',
                CHECK_MONEY_SUM: 'Pay more than the amount paid',
                NOCOUPON: 'No coupon',
                CHECK_MEMBER: 'Please complete all customer information.',
                NO_MONEY: 'Please enter the amount',
                DISCOUNT_KREN: 'Discount over the bill price',
                PERSEND: 'The percentage discount must be less than 100.'
            },
            CONFIRM: {
                TITLE: 'You want to delete',
                YES_NO: 'Yes or No',
                CF_SAVE: 'Confirm the recording',
                CF_CLEAN: 'Do you want to clear all items?',
                CF_CANCEL: 'Confirm the cancellation of the bill.',
                WARNING_DELETED: 'Warning, deleting a post-sale item may cause problems with calculation results in the report.'
            },
            SUM_SALE_DAY: 'Today\'s sales',
            SUM_SALE_MON: 'Sales this month'
        },
    },
};

